import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useMemo } from 'react';
import { motion } from 'framer-motion';
import { Card } from './Card';
const SUIT_ORDER = ['hearts', 'diamonds', 'clubs', 'spades'];
const RANK_ORDER = ['A', '2', '3', '4', '5', '6', '7', '8', '9', '10', 'J', 'Q', 'K'];
export const Hand = memo(function Hand({ cards, selectedCards, onCardSelect, disabled }) {
    // Memoize sorted cards to avoid re-sorting on every render
    const sortedCards = useMemo(() => {
        return [...cards].sort((a, b) => {
            // Joker am Ende
            if (a.suit === 'joker')
                return 1;
            if (b.suit === 'joker')
                return -1;
            // Nach Farbe sortieren
            const suitDiff = SUIT_ORDER.indexOf(a.suit) -
                SUIT_ORDER.indexOf(b.suit);
            if (suitDiff !== 0)
                return suitDiff;
            // Nach Rang sortieren
            return RANK_ORDER.indexOf(a.rank) -
                RANK_ORDER.indexOf(b.rank);
        });
    }, [cards]);
    return (_jsxs("div", { className: "w-full overflow-x-auto pb-4", children: [_jsx(motion.div, { className: "flex justify-center gap-2 min-w-max px-4", initial: "hidden", animate: "visible", variants: {
                    visible: {
                        transition: {
                            staggerChildren: 0.05,
                        },
                    },
                }, children: sortedCards.map((card, index) => (_jsx(motion.div, { variants: {
                        hidden: { opacity: 0, y: 50 },
                        visible: { opacity: 1, y: 0 },
                    }, style: {
                        // Leichtes Überlappen bei vielen Karten
                        marginLeft: index > 0 && cards.length > 8 ? -40 : 0,
                        zIndex: selectedCards.has(card.id) ? 100 : index,
                    }, children: _jsx(Card, { card: card, isSelected: selectedCards.has(card.id), onClick: () => onCardSelect(card.id), disabled: disabled, animate: false }) }, card.id))) }), cards.length > 0 && !disabled && (_jsx("p", { className: "text-center text-white/70 text-sm mt-2", children: "Klicke auf Karten um sie auszuw\u00E4hlen" })), _jsxs("div", { className: "text-center text-white font-semibold mt-2", children: [cards.length, " Karten auf der Hand"] })] }));
});
//# sourceMappingURL=Hand.js.map